var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var LegacyAPIHTTPDataSource_1;
import { IAPIHTTPDataSourceType } from '../APIHTTPDataSource/IAPIHTTPDataSource';
import { injectable } from '../../Decorators/Injectable';
import { inject } from '../../Decorators/Inject';
import { Observable } from '../../Observable/Observable';
import axios from 'axios';
let LegacyAPIHTTPDataSource = LegacyAPIHTTPDataSource_1 = class LegacyAPIHTTPDataSource {
    static get httpClient() {
        return LegacyAPIHTTPDataSource_1._httpClient;
    }
    static errorHandler(error) { }
    static setErrorHandler(fn) {
        LegacyAPIHTTPDataSource_1.errorHandler = fn;
    }
    static setHTTPClient(httpClient) {
        LegacyAPIHTTPDataSource_1._httpClient = httpClient;
    }
    constructor(apiDataSource) {
        this.apiDataSource = apiDataSource;
        this.configuration = {};
        this.debugMessages = new Observable();
        this.interceptor = new Observable();
        this.interceptor.observe(this, response => {
            if (response.error && response.error.length > 0) {
                response.error.forEach(error => {
                    LegacyAPIHTTPDataSource_1.errorHandler(error);
                });
            }
        });
    }
    mock() {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { mocked: true });
        return this.configuration;
    }
    unmock() {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { mocked: false });
        return this.configuration;
    }
    setAPIVersion(apiVersion) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { apiVersion });
        return this.configuration;
    }
    setNamespace(namespace) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { namespace });
        return this.configuration;
    }
    setServerURL(serverUrl) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), { serverUrl });
        return this.configuration;
    }
    setSID(sid) {
        return this.setConfiguration({ sid });
    }
    setLastSID(lastSid) {
        return this.setConfiguration({ lastSid });
    }
    setDevice(device) {
        return this.setConfiguration({ device });
    }
    setApplicationBuild(applicationBuild) {
        return this.setConfiguration({ applicationBuild });
    }
    setReactBuild(reactBuild) {
        return this.setConfiguration({ reactBuild });
    }
    setProfile(profile) {
        return this.setConfiguration({ profile });
    }
    setApplicationToken(applicationToken) {
        return this.setConfiguration({ applicationToken });
    }
    setConfiguration(configuration) {
        this.configuration = Object.assign(Object.assign({}, this.configuration), configuration);
        return this.configuration;
    }
    get(params) {
        return this.request(Object.assign({ method: 'GET' }, params));
    }
    post(params) {
        return this.request(Object.assign({ method: 'POST' }, params));
    }
    delete(params) {
        return this.request(Object.assign({ method: 'DELETE' }, params));
    }
    createError(code, message = 'Something went wrong') {
        return { error: [{ message, code }] };
    }
    getServerParams(namespace, options) {
        var _a, _b, _c, _d, _e;
        if (this.configuration.mocked && !namespace.startsWith('mock')) {
            namespace = `mock/${namespace}`;
        }
        let serverUrl = ((_b = (_a = this.configuration) === null || _a === void 0 ? void 0 : _a.serverUrl) === null || _b === void 0 ? void 0 : _b.replace(/^\/+|\/$/gm, '')) || '';
        if (serverUrl.endsWith('/')) {
            serverUrl = serverUrl.slice(0, serverUrl.length - 1);
        }
        if (!serverUrl.includes('/api')) {
            serverUrl += '/api';
        }
        const url = serverUrl + '/' + namespace;
        const config = Object.assign(Object.assign({}, options), { headers: {} });
        if ((_c = this.configuration) === null || _c === void 0 ? void 0 : _c.sid) {
            config.headers.Authorization = this.configuration.sid;
        }
        if ((_d = this.configuration) === null || _d === void 0 ? void 0 : _d.applicationToken) {
            config.headers['X-Client-Token'] = this.configuration.applicationToken;
        }
        if ((_e = this.configuration) === null || _e === void 0 ? void 0 : _e.profile) {
            config.headers['X-Client-Profile'] = this.configuration.profile;
        }
        return { url, config };
    }
    sterilization(response) {
        if (response.statusText !== 'OK' && (response.status < 200 || response.status > 299)) {
            return Promise.reject(this.createError(response.status));
        }
        let data = this.createError(-1);
        if (response.data.responses) {
            data = response.data.responses[0];
        }
        else if (response.data.data) {
            data = response.data.data;
        }
        if (data.error) {
            return Promise.reject(data);
        }
        this.fireInterceptors(data);
        return Promise.resolve(data);
    }
    handleError(timeout, error) {
        let errorData = error.error
            ? error
            : this.createError(100100, 'Connection error');
        if (timeout == null) {
            errorData = this.createError(-1, 'Request timeout');
        }
        this.fireInterceptors(errorData);
        return Promise.reject(errorData);
    }
    request(params) {
        if (!params.ac) {
            params.ac = new AbortController();
        }
        let { url, config } = this.getServerParams(params.namespace || this.configuration.namespace || '');
        const timeout = 15000;
        url += `/${params.path}`;
        const data = {
            Resources: [params.params]
        };
        let id = setTimeout(() => {
            id = null;
            params.ac.abort();
        }, timeout);
        return LegacyAPIHTTPDataSource_1.httpClient.post(url, data, config)
            .then(response => this.sterilization(response))
            .then(result => {
            var _a, _b;
            result = {
                data: (_a = result[0]) === null || _a === void 0 ? void 0 : _a[((_b = params === null || params === void 0 ? void 0 : params.params) === null || _b === void 0 ? void 0 : _b.name) || '']
            };
            this.logCurl(url, data, config, result);
            return result;
        })
            .catch(error => {
            var _a, _b, _c, _d;
            this.logCurl(url, data, config, error);
            params.path !== 'exceptions' && this.apiDataSource.logException({
                path: url,
                exception: error.code || ((_b = (_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.code),
                message: error.message || ((_d = (_c = error === null || error === void 0 ? void 0 : error.error) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.message),
                body: data,
                external_identifier: !error.code && error.message
                    ? 'JS'
                    : undefined
            });
            return this.handleError(id, error);
        })
            .finally(() => {
            if (id) {
                clearTimeout(id);
            }
        });
    }
    logCurl(url, data, config, response) {
        var _a;
        this.debugMessages.next({
            type: 'request',
            data: {
                curl: `curl -X POST ${url} \n ${Object.entries(config.headers || {}).reduce((acc, [key, value]) => `${acc}${acc ? ' \n ' : ''}-H '${key}: ${value}'`, '')} ${((_a = config.headers) === null || _a === void 0 ? void 0 : _a['Content-Type']) ? '' : `\n -H 'Content-Type: application/json'`} \n -d '${JSON.stringify(data)}'`,
                response
            }
        });
    }
    fireInterceptors(response) {
        this.interceptor.next(response);
    }
};
LegacyAPIHTTPDataSource._httpClient = axios;
LegacyAPIHTTPDataSource = LegacyAPIHTTPDataSource_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(IAPIHTTPDataSourceType)),
    __metadata("design:paramtypes", [Object])
], LegacyAPIHTTPDataSource);
export { LegacyAPIHTTPDataSource };
